import React, { useEffect, useRef, useState } from 'react';
import './login.css';
import { useNavigate } from 'react-router-dom';
import { DrugExceptionsClient } from '../../client/drug-exceptions-client';
import { AccessType } from '../../model/Reformulary';
import GetLangConfig from '../../util/LangUtil';
import { TextField } from '@mui/material';

interface HandleError {
    handleError: Function;
}

export default function LogIn(props: HandleError) {
    const [email, updateEmail] = useState('');
    const [password, updatePassword1] = useState('');
    const langConfig = GetLangConfig('login');
    const history = useNavigate();

    const userId = JSON.parse(sessionStorage.getItem('userId') || 'null');
    const userIdentityObject = JSON.parse(sessionStorage.getItem('userIdentityObject') || 'null');

    const updatePassword = (p: string) => {
        updatePassword1(p);
    };

    useEffect(() => {
        if (userId !== null) {
            const role = userId.role;

            if (role === AccessType[AccessType.MEMBER_CLAIMANT_ACCESS] || role === AccessType[AccessType.NON_MEMBER_CLAIMANT_ACCESS]) {
                history('/dashboard');
            } else if (role === AccessType[AccessType.ADMIN_ACCESS]) {
                history('/admin/dashboard');
            } else if (role === AccessType[AccessType.ASSESSOR_ACCESS]) {
                history('/assessor/dashboard');
            }
        }
    }, [userId, history]);

    const login = async () => {
        const drugExceptionsClient = new DrugExceptionsClient();
        try {
            const response = await drugExceptionsClient.api.post('/auth/login', {
                email,
                password,
            });

            sessionStorage.setItem('userId', JSON.stringify(response.data));

            const role = response.data.role;
            const headers = { Authorization: `Bearer ${response.data.authToken}` };

            if (role === AccessType[AccessType.MEMBER_CLAIMANT_ACCESS] || role === AccessType[AccessType.NON_MEMBER_CLAIMANT_ACCESS]) {
                const userIDResponse = await drugExceptionsClient.api.get(`/claimants/user/${response.data.id}`, { headers: headers });
                sessionStorage.setItem('userIdentityObject', JSON.stringify(userIDResponse.data));
                history('/dashboard');
            } else if (role === AccessType[AccessType.ADMIN_ACCESS]) {
                const userIDResponse = await drugExceptionsClient.api.get(`/administrators/user/${response.data.id}`, { headers: headers });
                sessionStorage.setItem('userIdentityObject', JSON.stringify(userIDResponse.data));
                history('/admin/dashboard');
            } else if (role === AccessType[AccessType.ASSESSOR_ACCESS]) {
                const userIDResponse = await drugExceptionsClient.api.get(`/assessors/user/${response.data.id}`, { headers: headers });
                sessionStorage.setItem('userIdentityObject', JSON.stringify(userIDResponse.data));
                history('/assessor/dashboard');
            } else {
                props.handleError('unknown role type');
            }

            props.handleError(undefined);

        } catch (error) {
            sessionStorage.removeItem('userId');
            sessionStorage.removeItem('userIdentityObject');
            props.handleError(error);
        }
    };

    return (
        <div className="login-container">
            <h1>{langConfig.login.header}</h1>
            <TextField
                id="email-address"
                label={langConfig.general.emailAddress}
                value={email}
                onChange={(e) => updateEmail(e.target.value)}
                error={email !== '' && !/\S+@\S+\.\S+/.test(email)}
                variant="filled"
                margin="normal"
                fullWidth
            />
            <TextField
                id="password"
                label={langConfig.login.password}
                value={password}
                onChange={(e) => updatePassword(e.target.value)}
                error={password !== '' && password.length < 6} // Example of password validation
                variant="filled"
                margin="normal"
                type="password"
                fullWidth
            />
            <div className="reset-password">
                <a onClick={(e) => history('/forgotPassword')}>{langConfig.login.resetPassword}</a>
            </div>
            <div>
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={login}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">{langConfig.login.loginBtn}</span>
                </button>
            </div>
        </div>
    );
}
